// extracted by mini-css-extract-plugin
module.exports = {"seatsList__items":"seatsList__items-30RjF","seatsList__item":"seatsList__item-QxPWz"};